export { default as useDiscountedPrice } from './use-discounted-price'
